export const AVATAR_COLORS = ['lime', 'orange', 'pink', 'blue', 'purple', 'coral', 'yellow'] as const;
export type AvatarColor = typeof AVATAR_COLORS[number];

export const AVATAR_ILLUSTRATIONS = ['user-silhouette', 'sheep-blue', 'balloon-dog-right', 'dinosaur-skeleton', 'robot-steve', 'dinosaur', 'fish', 'ghost', 'mouse', 'pig', 'pigeon'] as const;
export type AvatarIllustration = typeof AVATAR_ILLUSTRATIONS[number];

export const AVATAR_CATALOG: readonly AvatarIllustration[] = [
  'sheep-blue',
  'balloon-dog-right',
  'dinosaur-skeleton',
  'robot-steve',
  'dinosaur',
  'fish',
  'ghost',
  'mouse',
  'pig',
  'pigeon',
] as const;

export const DEFAULT_AVATAR_ILLUSTRATION: AvatarIllustration = 'user-silhouette';
export const DEFAULT_AVATAR_COLOR: AvatarColor = 'blue';

// Avatar values reach us as free-form strings (API payloads, stored user rows), so every read
// narrows through these rather than casting — one catalogue, one set of guards.
export const isValidIllustration = (value: unknown): value is AvatarIllustration =>
  typeof value === 'string' && (AVATAR_ILLUSTRATIONS as readonly string[]).includes(value);

export const isValidColor = (value: unknown): value is AvatarColor =>
  typeof value === 'string' && (AVATAR_COLORS as readonly string[]).includes(value);
